import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000/api';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json'
  }
});

// Chat API
export const chatAPI = {
  createSession: async () => {
    const response = await api.post('/chat/session');
    return response.data;
  },

  sendMessage: async (sessionId, message, extraData = {}) => {
    const response = await api.post('/chat/message', {
      sessionId,
      message,
      ...extraData
    });
    return response.data;
  },

  getChatHistory: async (sessionId, limit = 50) => {
    const response = await api.get(`/chat/history/${sessionId}`, {
      params: { limit }
    });
    return response.data;
  }
};

// Product API
export const productAPI = {
  searchProducts: async (query, limit = 5) => {
    const response = await api.get('/products/search', {
      params: { q: query, limit }
    });
    return response.data;
  },

  getProduct: async (id) => {
    const response = await api.get(`/products/${id}`);
    return response.data;
  },

  getCategories: async () => {
    const response = await api.get('/products');
    return response.data;
  }
};

// Contact API
export const contactAPI = {
  submitForm: async (formData) => {
    const response = await api.post('/contact/submit', formData);
    return response.data;
  }
};

export default api;
